import { generateHash } from "./generateHash.js";
import { getCookie } from "../../../helper/cookies/getCookie.js";
export async function canRememberCaptcha(path, method) {
  const cleanPath = path.replace(/^(\/api)/u, '');
  const uppercaseMethod = method.toUpperCase();
  const hash = await generateHash(`${uppercaseMethod}${cleanPath}`);
  const hasCookie = getCookie(document.cookie, `GATEWAY_REMEMBER_CAPTCHA_CHECK_${hash}`);
  return !!hasCookie;
}